import React from 'react'
import PropTypes from 'prop-types'
import Link from '../components/base/link'
import Helmet from 'react-helmet'
import Header from '../components/hybrid/header'
import Footer from '../components/hybrid/footer'
import Button from 'material-ui/Button';
import { MuiThemeProvider } from 'material-ui/styles'
import mui from 'themes/mui'
import css from './main.css'
import normalize from './normalize.css'
import MainHelmet from 'components/base/mainHelmet'
import Blank from './blank'


const TemplateWrapper = ({ children, location }) => {
  return (
    <Blank>
      <div css={{ display: 'flex', minHeight: '100vh', flex: 1, flexDirection: 'column'}}>
        <MainHelmet />
        <Header location={location} />
        <div css={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
          {children()}
        </div>
        <Footer />
      </div>
    </Blank>
  )
}
  

TemplateWrapper.propTypes = {
  children: PropTypes.func,
}

export default TemplateWrapper



// WEBPACK FOOTER //
// ./src/layouts/index.js